import {AuthoringQuestionSetModelV1} from 'resources/GeneratedModels/AuthoringQuestionSet/AuthoringQuestionSetModel.v1';

import {authoringQuestionSetModelValidators} from 'resources/validators/AuthoringQuestionSetModel.validators';

import {questionSetExtensions} from './questionSet.extensions';
import {authoringQuestionSetExtensions} from './authoringQuestionSet.extensions';

AuthoringQuestionSetModelV1.extend(questionSetExtensions, authoringQuestionSetExtensions);
AuthoringQuestionSetModelV1.addValidators(authoringQuestionSetModelValidators);

export {AuthoringQuestionSetModelV1};
